import { Fragment, useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { StatementInvoiceService } from '../StatementInvoiceService';
import { InvoiceService } from '../../hoa-don/InvoiceService';
import { getLawBasesText } from '../../../utils/statementHelper';

import { useForm } from "../../../shared/hooks/Form";
import { ToastService } from "../../../AppToast";

import { FormatDisplay } from '../../../shared/format';
import { translateError } from '../../../shared/language';
import { useSign } from '../../../shared/component/Sign';
import moment from 'moment';
import { DialogSendEmail } from '../../hoa-don/component/DialogSendEmail';
import { ConfirmDialogService } from '../../../AppConfirmDialog';

export const DialogStatement = ({
  title,
  display,
  setDisplay,
  selectedItem,
  reloadLazyData,
  documentType,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [isRequiredBuyerPersonContact, setIsRequiredBuyerPersonContact] =
    useState(false);
  const [emailDialogVisible, setEmailDialogVisible] = useState(false);

  const handleComplete = () => {
    load();
    // reloadLazyData();
  };

  const { renderSign, sign } = useSign({ onComplete: handleComplete });

  interface StatementData {
    id?: string;
    dateSign?: string;
    buyerDateSign?: string;
    documentDate?: Date | string;
    invoiceId?: string;
    invoiceSerial?: string;
    invoiceNumber?: string;
    invoiceDate?: string;
    reasonAfter?: string;
    documentType?: string;
    [key: string]: any; // Add this if there are more dynamic fields
  }

  const [id, setId] = useState<string | null>(null);
  const [data, setData] = useState<StatementData>({});

  useEffect(() => {
    if (display) {
      load();
    } else {
      reloadLazyData();
    }
  }, [display]); // eslint-disable-line react-hooks/exhaustive-deps

  const load = async () => {
    try {
      const data = await StatementInvoiceService.getByInvoice(
        selectedItem?.invoiceId || selectedItem?.id,
      );
      if (data && data.id) {
        if (!data.reason) {
          data.reason = selectedItem.invoiceNote;
        }
        if (data.id === '00000000-0000-0000-0000-000000000000') {
          const rawInvoiceDate = data.invoiceDate || selectedItem?.relatedInvoiceDate || selectedItem?.invoiceDate;
          data.documentDate = rawInvoiceDate ? new Date(rawInvoiceDate) : new Date();
        } else if (data.documentDate) {
          data.documentDate = new Date(data.documentDate);
        }

        if (!data.invoiceId) {
          data.invoiceId = selectedItem.invoiceId;
        }

        if (!data.invoiceListNumber) {
          data.invoiceListNumber =
            selectedItem?.invoiceListNumber ||
            selectedItem?.relatedInvoiceListNumber;
        }
        if (!data.invoiceListDate) {
          data.invoiceListDate =
            selectedItem?.invoiceListDate || selectedItem?.relatedInvoiceListDate;
        }

        if (data.documentType !== InvoiceService.documentType_Cancel) {
          if (selectedItem?.relatedInvoiceSerial) {
            data.invoiceSerial =
              selectedItem.relatedInvoiceSerial.length === 6
                ? `${selectedItem.relatedTemplateCode}${selectedItem.relatedInvoiceSerial}`
                : selectedItem.relatedInvoiceSerial;
          }
          data.invoiceNumber = selectedItem?.relatedInvoiceNumber || data.invoiceNumber;
          data.invoiceDate = selectedItem?.relatedInvoiceDate || data.invoiceDate;
        }

        if (!data.reasonAfter) {
          data.reasonAfter = getLawBasesText(data.documentDate);
        }

        // data.documentType = documentType;
        setData(data);
        setValue(data);

        if (data.id === "00000000-0000-0000-0000-000000000000") {
          setId(null);
        } else {
          setId(data.id);
        }
        return data;
      }
      return null;
    } catch (error) {
      // handle error if needed
      return null;
    }
  };

  const getInvoiceId = () => {
    let invoiceId = selectedItem.invoiceId;
    if (
      documentType != InvoiceService.documentType_Cancel &&
      selectedItem.relatedInvoiceId
    ) {
      invoiceId = selectedItem.relatedInvoiceId;
    }
    return invoiceId;
  };

  const doSign = () => {
    // sign({
    //   "CommandName": "SignSS04",
    //   "Id": selectedItems['id']
    // });
  };

  const {
    render: renderForm,
    setValue,
    valid: formValid,
    getValue,
  } = useForm({
    fields: [
      { field: "id", type: "hidden" },
      { field: "documentType", type: "hidden" },
      { field: "invoiceId", type: "hidden" },
      { field: "invoiceSerial", type: "hidden" },
      { field: "taxAuthorityCode", type: "hidden" },
      { field: "totalAmount", type: "hidden" },
      { field: "invoiceNumber", type: "hidden" },
      { field: "invoiceDate", type: "hidden" },
      { field: "invoiceListNumber", type: "hidden" },
      { field: "invoiceListDate", type: "hidden" },
      {
        type: "custom",
        className: "md:col-12 text-center mb-0 mt-1",
        body: (
          <h3 className="mb-0 uppercase">Cộng hoà xã hội chủ nghĩa Việt Nam</h3>
        ),
      },
      {
        type: "custom",
        className: "md:col-12 text-center mb-4",
        body: <b>Độc lập - Tự do - Hạnh phúc</b>,
      },
      {
        type: "custom",
        className: "md:col-12 text-center mb-0",
        body: (
          <h3 className="mb-0 uppercase">
            Biên bản{" "}
            {Number(data.documentType) === InvoiceService.documentType_Cancel
              ? "huỷ"
              : Number(data.documentType) ===
                  InvoiceService.documentType_Substitute
                ? "thay thế"
                : "điều chỉnh"}{" "}
            hoá đơn
          </h3>
        ),
      },
      {
        field: "documentNo",
        header: "Số biên bản",
        InputTextProps: { maxLength: 400 },
        className: "md:col-12",
        labelClassName: "md:col-5 justify-content-end",
        inputClassName: "md:col-3",
      },
      {
        field: "reasonAfter",
        header: "",
        type: "InputTextarea",
        className: "md:col-12",
        inputClassName: "font-italic",
      },
      {
        field: "documentDate",
        header: "Hôm nay, ngày",
        type: "Calendar",
        className: "md:col-4",
        labelClassName: "md:col-5",
        inputClassName: "md:col-7",
      },
      {
        type: "custom",
        className: "md:col-6 pt-2",
        body: <p>Chúng tôi gồm có:</p>,
      },
      {
        field: "sellerLegalName",
        header: "Bên A (Bên bán)",
        type: "text",
        className: "md:col-12",
        labelClassName: "md:col-2 font-bold",
        inputClassName: "md:col-10 font-bold h-35 lh-35",
      },
      {
        field: "sellerAddress",
        header: "Địa chỉ",
        type: "text",
        className: "md:col-12",
        labelClassName: "md:col-2",
        inputClassName: "md:col-10 h-35 lh-35",
      },
      {
        field: "sellerTaxCode",
        header: "Mã số thuế",
        type: "text",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8 h-35 lh-35",
      },
      {
        field: "sellerTel",
        header: "Số điện thoại",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "sellerPersonContact",
        header: "Đại diện",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "sellerPosition",
        header: "Chức vụ",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "buyerLegalName",
        header: "Bên B (Bên mua)",
        className: "md:col-12",
        labelClassName: "md:col-2 font-bold",
        inputClassName: "md:col-10 font-bold",
        required: true,
      },
      {
        field: "buyerAddress",
        header: "Địa chỉ",
        className: "md:col-12",
        labelClassName: "md:col-2",
        inputClassName: "md:col-10",
        required: true,
      },
      {
        field: "buyerTaxCode",
        header: "Mã số thuế",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "buyerTel",
        header: "Số điện thoại",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "buyerPersonContact",
        header: "Đại diện",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
        required: isRequiredBuyerPersonContact,
      },
      {
        field: "buyerPosition",
        header: "Chức vụ",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        field: "buyerEmail",
        header: "Email",
        type: "email",
        className: "md:col-6",
        labelClassName: "md:col-4",
        inputClassName: "md:col-8",
      },
      {
        type: "template",
        className: "md:col-12",
        template: (item) => {
          let {
            invoiceSerial,
            invoiceNumber,
            invoiceDate,
            invoiceListNumber,
            invoiceListDate,
          } = item;
          let form, serial;
          if (invoiceSerial) {
            form = invoiceSerial.substring(0, 1);
            serial = invoiceSerial.substring(1, invoiceSerial.length);
          }
          if (invoiceDate) {
            invoiceDate = FormatDisplay.date(invoiceDate);
          }
          if (invoiceListDate) {
            invoiceListDate = FormatDisplay.date(invoiceListDate);
          }

          if (
            Number(data.documentType) === InvoiceService.documentType_Cancel
          ) {
            return (
              <i>
                Hai bên thống nhất lập biên bản này để thu hồi và huỷ hoá đơn có
                mẫu số {form}, ký hiệu {serial}, số {invoiceNumber}, ngày{" "}
                {invoiceDate} theo quy định.
              </i>
            );
          }

          if (
            Number(data.documentType) === InvoiceService.documentType_Substitute
          ) {
            if (invoiceListNumber || invoiceListDate) {
              return (
                <i>
                  Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn Thay thế cho nhiều hóa đơn sai sót kèm theo bảng kê có Số {invoiceListNumber || "...."},
                  Ngày {invoiceListDate || "...."} theo quy định.
                </i>
              );
            }
            return (
              <i>
                Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn Thay thế cho hóa đơn có
                mẫu số {form}, ký hiệu {serial}, số {invoiceNumber}, ngày{" "}
                {invoiceDate} theo quy định.
              </i>
            );
          }
          if (
            Number(data.documentType) === InvoiceService.documentType_Adjust
          ) {
            if (invoiceListNumber || invoiceListDate) {
              return (
                <i>
                  Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn Điều chỉnh cho nhiều hóa đơn sai sót kèm theo bảng kê có Số {invoiceListNumber || "...."},
                  Ngày {invoiceListDate || "...."} theo quy định.
                </i>
              );
            }
            return (
              <i>
                Hai bên thống nhất lập biên bản này để xác nhận sai sót và lập hóa đơn Điều chỉnh cho hóa đơn có
                mẫu số {form}, ký hiệu {serial}, số {invoiceNumber}, ngày{" "}
                {invoiceDate} theo quy định.
              </i>
            );
          }
        },
      },
      {
        field: "reason",
        header: `Lý do ${Number(data.documentType) === InvoiceService.documentType_Cancel ? "huỷ" : Number(data.documentType) === InvoiceService.documentType_Substitute ? "thay thế" : "điều chỉnh"}`,
        className: "md:col-12",
        labelClassName: "md:col-2",
        inputClassName: "md:col-10",
        required: true,
      },
      {
        type: "custom",
        className: "md:col-12",
        body: (
          <p>
            Chúng tôi xin cam đoan các thông tin khai ở trên là hoàn toàn chính
            xác. Nếu có bất kỳ sai sót nào chúng tôi xin chịu trách nhiệm trước
            pháp luật.
          </p>
        ),
      },
      {
        type: "custom",
        className: "md:col-6 mt-3",
        body: (
          <div className="flex flex-column align-items-center gap-2">
            <div className="col-12 text-center">
              <b className="uppercase">Đại diện bên A</b>
            </div>
            <div className="col-12 text-center">
              <i>(Chữ ký số, chữ ký điện tử)</i>
            </div>
            {data?.status === 2 && (
              <div className="grid grid-nogutter relative border-2 border-solid border-green-500 text-green-500 px-4 w-9">
                <span className="col-12">Signature valid</span>
                <span className="col-3">Kí bởi:</span>
                <span className="col-9">{data?.sellerLegalName}</span>
                <span className="col-3">Ngày ký:</span>
                <span className="col-9">
                  {moment(data?.dateSign).format("DD/MM/YYYY HH:mm:ss")}
                </span>
                <img
                  className="col-2 absolute"
                  style={{
                    top: "60%",
                    right: "10px",
                    transform: "translateY(-50%)",
                  }}
                  src={"assets/layout/images/check.png"}
                  alt=""
                />
              </div>
            )}
            {/* <div className="col-12 mt-3 text-center un-fluid">
              <Button label="Ký điện tử" icon="pi pi-user-edit" className="p-button-outlined p-button-sm" onClick={doSign}/>
            </div> */}
          </div>
        ),
      },
      {
        type: "custom",
        className: "md:col-6 mt-3",
        body: (
          <div className="flex flex-column align-items-center gap-2">
            <div className="col-12 text-center">
              <b className="uppercase">Đại diện bên B</b>
            </div>
            <div className="col-12 text-center">
              <i>(Chữ ký số, chữ ký điện tử)</i>
            </div>
            {data?.buyerStatus === 2 && (
              <div className="grid grid-nogutter relative border-2 border-solid border-green-500 text-green-500 px-4 w-9">
                <span className="col-12">Signature valid</span>
                <span className="col-3">Kí bởi:</span>
                <span className="col-9">{data?.buyerLegalName}</span>
                <span className="col-3">Ngày ký:</span>
                <span className="col-9">
                  {moment(data?.buyerDateSign).format("DD/MM/YYYY HH:mm:ss")}
                </span>
                <img
                  className="col-2 absolute"
                  style={{
                    top: "60%",
                    right: "10px",
                    transform: "translateY(-50%)",
                  }}
                  src={"assets/layout/images/check.png"}
                  alt=""
                />
              </div>
            )}
          </div>
        ),
      },
    ],
    layout: "Horizontal",
    formClassName: "paper",
  });

  const print = () => {
    window.open(StatementInvoiceService.getPdfUrl(id), "_blank");
  };

  const submit = async (isSign?: boolean) => {
    if (!submitting && formValid()) {
      setSubmitting(true);

      try {
        const dataValue = getValue();
        let method;
        if (dataValue.id === "00000000-0000-0000-0000-000000000000") {
          delete dataValue.id;
          method = StatementInvoiceService.create({ ...dataValue, status: 1 });
        } else {
          method = StatementInvoiceService.update(dataValue.id, dataValue);
        }
        if (data.status === 2) {
          ConfirmDialogService.confirmSignStatement(async () => {
            await method;
            const loadedData = await load();
            if (isSign) {
              sign({
                CommandName: "StatementInvoice",
                Id: loadedData.id,
                InvoiceIdArray: [loadedData.id],
              });
            }
            ToastService.success();
          });
          return;
        }
        await method;
        const loadedData = await load();
        if (isSign) {
          sign({
            CommandName: "StatementInvoice",
            Id: loadedData.id,
            InvoiceIdArray: [loadedData.id],
          });
        }
        ToastService.success();
        return;
        // reloadLazyData();
      } catch ({ response }) {
        ToastService.error(translateError(response));
      } finally {
        setSubmitting(false);
      }
    }
  };

  const signItem = () => {
    const data = getValue();

    sign({
      CommandName: "StatementInvoice",
      Id: data.id,
      InvoiceIdArray: [data.id],
    });
  };

  useEffect(() => {
    if (getValue().buyerTaxCode) {
      return setIsRequiredBuyerPersonContact(true);
    }
    return setIsRequiredBuyerPersonContact(false);
  }, [getValue().buyerTaxCode]); // eslint-disable-line react-hooks/exhaustive-deps

  const documentDateValue = getValue().documentDate;
  const reasonAfterValue = getValue().reasonAfter;

  useEffect(() => {
    if (!documentDateValue) return;

    const lawBaseBefore = getLawBasesText(new Date('2026-06-01'));
    const lawBaseAfter = getLawBasesText(new Date('2026-07-01'));

    const clean = (str: string) => str ? str.replace(/\s+/g, ' ').trim() : '';

    const cleanReason = clean(reasonAfterValue);
    const cleanBefore = clean(lawBaseBefore);
    const cleanAfter = clean(lawBaseAfter);

    const targetReason = getLawBasesText(documentDateValue);

    if (!cleanReason || cleanReason === cleanBefore || cleanReason === cleanAfter) {
      if (cleanReason !== clean(targetReason)) {
        setValue({
          ...getValue(),
          reasonAfter: targetReason
        });
      }
    }
  }, [documentDateValue]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <Fragment>
      <Dialog
        header="Lập biên bản"
        visible={display}
        style={{ width: "890px" }}
        position="top"
        onHide={() => setDisplay(false)}
      >
        {renderForm()}

        <div className="flex justify-content-end mt-2">
          <Button
            label="Lưu"
            icon="pi pi-check"
            className="p-button-outlined p-button-sm mr-2"
            onClick={() => submit(false)}
            loading={submitting}
          />
          {id && (
            <Button
              label="Ký"
              icon="pi pi-check"
              className="p-button-outlined p-button-sm mr-2"
              onClick={signItem}
            />
          )}
          <Button
            label="Lưu & ký"
            icon="pi pi-check"
            className="p-button-outlined p-button-sm mr-2"
            onClick={() => {
              submit(true);
            }}
            loading={submitting}
          />
          {id && (
            <Button
              label="In"
              icon="pi pi-print"
              className="p-button-outlined p-button-sm mr-2"
              onClick={print}
            />
          )}
          {data.id !== "00000000-0000-0000-0000-000000000000" && (
            <Button
              label="Gửi hoá đơn cho người mua ký"
              icon="pi pi-envelope"
              className="p-button-outlined p-button-sm mr-2"
              onClick={() => setEmailDialogVisible(true)}
            />
          )}
        </div>
      </Dialog>
      <DialogSendEmail
        display={emailDialogVisible}
        setDisplay={setEmailDialogVisible}
        selectedItems={data}
        sendType={8}
      />
      {renderSign()}
    </Fragment>
  );
};
